<template>
  <div style="width: 100%; height: 100%">
    <div style="width: 100%; height: 100%" ref="root">
      <div class="text-h5" style="font-weight: bold; color: #2f75bc; margin-bottom: 3vmin" v-if="readyMode == true && rightPose === false">もうすこし！</div>
      <div class="text-h5" style="font-weight: bold; color: #ea6b40; margin-bottom: 3vmin" v-if="readyMode == true && rightPose === true">いいかんじ！</div>
      <canvas id="canvas"></canvas>
    </div>
  </div>
</template>

<script>
  import { defineComponent, onMounted, ref, inject } from '@vue/composition-api'
  import * as tmPose from '@teachablemachine/pose'
  import { key } from '../store'

  export default defineComponent({
    name: 'CapturePose',
    props: {
      readyMode: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const root = ref()
      const store = inject(key)
      if (!store) {
        throw new Error('')
      }
      const URL = '/pose_model/'
      let model
      let webcam
      let ctx
      let labelContainer
      let maxPredictions
      let prediction
      let rightPose = ref(false)

      const blockImgs = {
        ヒト: '/img/pose_blocks/table_pose_human.png',
        ライオン: '/img/pose_blocks/table_pose_lion.png',
        トリ: '/img/pose_blocks/table_pose_bird.png',
        ウサギ: '/img/pose_blocks/table_pose_rabbit.png',
      }

      onMounted(() => init())

      function judgePose() {
        let max_prediction = { className: '', probability: 0 }
        for (let i = 0; i < maxPredictions; i++) {
          if (max_prediction.probability < prediction[i].probability.toFixed(2)) {
            max_prediction = { className: prediction[i].className, probability: prediction[i].probability.toFixed(2) }
          }
        }
        return max_prediction
      }

      async function init() {
        const modelURL = URL + 'model.json'
        const metadataURL = URL + 'metadata.json'

        // load the model and metadata
        // Refer to tmImage.loadFromFiles() in the API to support files from a file picker
        // Note: the pose library adds a tmPose object to your window (window.tmPose)
        model = await tmPose.load(modelURL, metadataURL)
        maxPredictions = model.getTotalClasses()

        // Convenience function to setup a webcam
        const size = Math.min(root.value.clientWidth, root.value.clientHeight, 500)
        const flip = !store.isRearCamera() // whether to flip the webcam
        webcam = new tmPose.Webcam(size, size, flip) // width, height, flip
        // prettier-ignore
        await webcam.setup({
          facingMode: store.isRearCamera() ? { exact: 'environment' } : 'user',
        }).catch((e) => alert('カメラとせつぞくできません。きりかえボタンをおしてカメラをきりかえてください。'))
        await webcam.play()
        window.requestAnimationFrame(loop)

        // append/get elements to the DOM
        const canvas = document.getElementById('canvas')
        canvas.width = size
        canvas.height = size
        ctx = canvas.getContext('2d')
        labelContainer = document.getElementById('label-container')
      }

      async function loop() {
        webcam.update() // update the webcam frame
        await predict()
        window.requestAnimationFrame(loop)
      }

      async function predict() {
        // Prediction #1: run input through posenet
        // estimatePose can take in an image, video or canvas html element
        const { pose, posenetOutput } = await model.estimatePose(webcam.canvas)
        // Prediction 2: run input through teachable machine classification model
        prediction = await model.predict(posenetOutput)

        const max_prediction = judgePose()
        if (document.getElementById('predictPose') == null) {
          const imgElement = document.createElement('img')
          imgElement.id = 'predictPose'
          labelContainer.appendChild(imgElement)
          imgElement.alt = '認識したポーズ'
          imgElement.style.width = '100%'
          imgElement.style.height = '100%'
          imgElement.style.objectFit = 'contain'
        }
        const domImgElement = document.getElementById('predictPose')
        let isUndefined = true
        Object.keys(blockImgs).map((data) => {
          if (data == max_prediction.className) {
            domImgElement.style.display = 'block'
            domImgElement.setAttribute('src', blockImgs[max_prediction.className])
            isUndefined = false
          }
        })
        if (isUndefined) {
          domImgElement.style.display = 'none'
        }

        validPose(pose)
        // finally draw the poses
        drawPose(pose)
      }

      function validPose(pose) {
        if (!pose) {
          return
        }
        pose.keypoints.forEach((keypoint) => {
          if (['rightShoulder', 'leftShoulder', 'leftHip', 'rightHip'].includes(keypoint.part)) {
            if (keypoint.score >= 0.5) {
              rightPose.value = true
            } else {
              rightPose.value = false
            }
          }
        })
        // console.log(rightPose)
      }

      function drawPose(pose) {
        if (webcam.canvas) {
          ctx.drawImage(webcam.canvas, 0, 0)
          // draw the keypoints and skeleton
          if (pose) {
            const minPartConfidence = 0.5
            tmPose.drawKeypoints(pose.keypoints, minPartConfidence, ctx)
            tmPose.drawSkeleton(pose.keypoints, minPartConfidence, ctx)
          }
        }
      }

      return {
        root,
        judgePose,
        rightPose,
      }
    },
  })
</script>
